module.exports = __webpack_public_path__ + "media/images/athletes/3596-6317e60a9d95bb9c264a4f4081ed1f1e.png";